import axios from "axios";
import authHeader from "./auth-header";
import AuthService from "./auth.service";
import { config } from "../config";

class ExtranetStatusService {
  getStatusByType(type) {
    return axios
      .get(`${config["apiUrl"]}/extranet/status/type`, {
        headers: authHeader(),
        params: { type }
      })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      })
  }

  createStatus(data) {
    return axios
      .post(`${config["apiUrl"]}/extranet/status`, data, { headers: authHeader() })
      .then((response) => {
        if (response.status == 201) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      })
  }

  updateStatus(id, data) {
    return axios
      .put(`${config["apiUrl"]}/extranet/status/${id}`, data, { headers: authHeader() })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      })
  }

  updateTypeOrder(status, workflow) {
    return axios
      .put(`${config["apiUrl"]}/extranet/status/orderType`, { status, workflow }, { headers: authHeader() })
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      })
  }
}

export default new ExtranetStatusService()
